module.exports = __webpack_public_path__ + "img/DigitalFederalCreditUnion.5bf1bebb.svg";